<template>
  <div class="medic-input">
    <v-select
      :options="options"
      v-model="medic"
      :reduce="medic => medic.pub"
      label="name"
      @search="UpdateMedics"
      @input="setSelected"
    >
      <template slot="no-options">Escribe para buscar médicos</template>
      <template slot="option" slot-scope="option">
        <div class="d-center">{{ option.name }}</div>
      </template>
    </v-select>
  </div>
</template>

<script>
import MedicsManager from "../managers/medicsManager";
import vSelect from "vue-select";
import gun from '../managers/gun'
export default {
  components: {
    vSelect
  },
  props: {
    medic: String
  },
  data() {
    return {
      searchString: "Buscar médico",
      options: []
    };
  },
  methods: {
    async UpdateMedics(search, loading) {
      loading(true);
      MedicsManager.GetMedicRegistrationContract(
        process.env.VUE_APP_MEDIC_REGISTRATION
      ).then(async contract => {
        var msg = await contract.methods.GetMedics();
        msg.call(async (i, medics) => {
          let options = []
          console.log("medics", medics)
          for(let medic of medics) {
            let profile = await gun.user(medic.pub).get('profile')
            console.log("profile")
            console.log(profile)
            options.push({name: profile.name, wallet: profile.wallet, pub: medic.pub})
          }
          this.options = options;
                loading(false);
        });
      });

    },
    setSelected() {
      this.$emit("update:medic", this.medic);
    }
  },
  created() {
    this.UpdateMedics()
  }
};
</script>

<style lang="scss" scoped>
img {
  height: auto;
  max-width: 2.5rem;
  margin-right: 1rem;
}

.d-center {
  display: flex;
  align-items: center;
}

.selected img {
  width: auto;
  max-height: 23px;
  margin-right: 0.5rem;
}

.v-select .dropdown li {
  border-bottom: 1px solid rgba(112, 128, 144, 0.1);
}

.v-select .dropdown li:last-child {
  border-bottom: none;
}

.v-select .dropdown li a {
  padding: 10px 20px;
  width: 100%;
  font-size: 1.25em;
  color: #3c3c3c;
}

.v-select .dropdown-menu .active > a {
  color: #fff;
}
</style>